import React, { useEffect, useState } from 'react'
import { supabase } from '../../lib/supabase'
import { Card, Badge, Button } from '../../components/UI'
import { AlertTriangle, RefreshCw } from 'lucide-react'

export default function ErrorsPage() {
    const [errors, setErrors] = useState([])
    const [loading, setLoading] = useState(true)

    const fetchErrors = async () => {
        setLoading(true)
        // CORRECCIÓN: Usar telemetry_events y hacer join con licenses
        const { data } = await supabase
            .from('telemetry_events')
            .select('*, licenses(client_name)') // JOIN crucial
            .eq('event_type', 'error')
            .order('created_at', { ascending: false })
            .limit(50)

        setErrors(data || [])
        setLoading(false)
    }

    useEffect(() => { fetchErrors() }, [])

    /* Componente de Fila para Tabla Desktop */
    const ErrorRow = ({ err, i }) => {
        // Extraer mensaje del payload si existe
        const message = err.payload?.message || err.message || 'Error desconocido'
        const stack = err.payload?.stack || ''
        const clientName = err.licenses?.client_name || 'Desconocido' // Mapeo correcto

        return (
            <tr key={i} className="hover:bg-white/5 transition-colors group">
                <td className="px-6 py-4 font-mono text-gray-400 text-xs whitespace-nowrap">
                    {new Date(err.created_at).toLocaleString()}
                </td>
                <td className="px-6 py-4">
                    <span className="font-bold text-white">{clientName}</span>
                </td>
                <td className="px-6 py-4">
                    <div className="max-w-md truncate text-red-400 font-mono text-xs" title={message}>
                        {message}
                    </div>
                </td>
                <td className="px-6 py-4">
                    <Badge status={'error'} />
                </td>
            </tr>
        )
    }

    /* Componente de Tarjeta para Móvil */
    const MobileErrorCard = ({ err }) => {
        const message = err.payload?.message || err.message || 'Error desconocido'
        const stack = err.payload?.stack || ''
        const clientName = err.licenses?.client_name || 'Desconocido'

        return (
            <Card className="border border-white/5 bg-white/5 p-4 mb-3">
                <div className="flex justify-between items-start mb-2">
                    <div className="font-bold text-white text-lg">{clientName}</div>
                    <Badge status={'error'} />
                </div>
                <div className="text-xs font-mono text-gray-500 mb-2">
                    {new Date(err.created_at).toLocaleString()}
                </div>
                <div className="bg-black/30 p-3 rounded border border-white/5 font-mono text-xs text-red-300 break-words">
                    {message}
                </div>
                {stack && (
                    <div className="mt-2 text-[10px] text-gray-600 font-mono truncate">
                        {stack.substring(0, 100)}...
                    </div>
                )}
            </Card>
        )
    }

    return (
        <div className="pb-20"> {/* Padding bottom extra para móvil */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
                <div>
                    <h1 className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-red-400 to-orange-600 flex items-center gap-3">
                        <AlertTriangle className="text-red-400" /> Errores Críticos
                    </h1>
                    <p className="text-gray-400 mt-1">Logs de excepciones en tiempo real</p>
                </div>
                <Button onClick={fetchErrors} variant="ghost" className="self-end md:self-auto"><RefreshCw size={18} /> Refrescar</Button>
            </div>

            {loading ? (
                <div className="flex justify-center p-12"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-500"></div></div>
            ) : (
                <div className="grid gap-4 lg:gap-0">
                    {/* Vista Desktop */}
                    <Card className="hidden lg:block p-0 overflow-hidden border border-white/5">
                        <table className="w-full text-left">
                            <thead className="bg-white/5 text-gray-400 text-xs uppercase tracking-wider">
                                <tr>
                                    <th className="px-6 py-4">Fecha</th>
                                    <th className="px-6 py-4">Proyecto</th>
                                    <th className="px-6 py-4">Mensaje de Error</th>
                                    <th className="px-6 py-4">Severidad</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-white/5">
                                {errors.map((err, i) => <ErrorRow key={i} err={err} i={i} />)}
                            </tbody>
                        </table>
                    </Card>

                    {/* Vista Móvil */}
                    <div className="lg:hidden">
                        {errors.map((err, i) => <MobileErrorCard key={i} err={err} />)}
                        {errors.length === 0 && <div className="text-gray-500 text-center py-8">Sin errores registrados 🎉</div>}
                    </div>
                </div>
            )}
        </div>
    )
}
